module.exports = __webpack_public_path__ + "img/bg-licence.3c3ace48.png";